import React from 'react'
import { motion } from 'framer-motion'
import SVG from 'react-inlinesvg'

import user from '../../../assets/icons/user.svg'
import chevron from '../../../assets/icons/chevron-styled.svg'
import bhvr from '../../../assets/icons/logos/bhvr.svg'

const NavUtils = (props) => {
  const theme = props.theme

  return (
    <nav
      name="Utilities Navigation"
      className={`${props.className ? props.className : ''}`}
    >
      <motion.a
        initial={{ opacity: 0, filter: 'blur(10px)' }}
        animate={{ opacity: 1, filter: 'blur(0px)' }}
        exit={{ opacity: 0, filter: 'blur(10px)' }}
        transition={{ duration: 0.5, delay: 0.5 }}
        title="Behaviour Interactive"
        href="https://www.bhvr.com/"
        target="_blank"
        rel="noreferrer"
        className={`
          h-auto w-auto mr-5 lg:mr-9 transition-all duration-300
          ${theme && theme.text && (`
            ${theme.text.default
              ? `text-${theme.text.default}`
              : 'text-white'
            } 
            ${theme.text.hover
              ? `hover:text-${theme.text.hover}`
              : 'hover:text-primary'
            }
          `)}
        `}
      >
        <SVG
          onError={error => console.log(error.message)}
          cacheRequests={true}
          preProcessor={code =>
            code.replace(/fill=".*?"/g, 'fill="currentColor"')
          }
          src={bhvr}
          className="block w-10 h-auto lg:w-11"
        />
      </motion.a>
      <motion.a
        initial={{ opacity: 0, filter: 'blur(10px)' }}
        animate={{ opacity: 1, filter: 'blur(0px)' }}
        exit={{ opacity: 0, filter: 'blur(10px)' }}
        transition={{ duration: 0.5, delay: 0.5 }}
        href={props.data && props.data.bhvrAccount ? props.data.bhvrAccount : 'https://account.bhvr.com'}
        target="_blank"
        rel="noreferrer"
        className={`
          flex items-center border border-solid lg:pt-[2px] lg:pb-[3px] px-[3px] lg:px-2 lg:py-2 transition-all duration-300
          ${theme && theme.text && (`
            ${theme.text.default
              ? `text-${theme.text.default} border-${theme.text.default}`
              : 'text-white border-white'
            } 
            ${theme.text.hover
              ? `hover:text-${theme.text.hover}`
              : 'hover:text-primary'
            }
          `)}
        `}
      >
        <SVG
          onError={error => console.log(error.message)}
          cacheRequests={true}
          preProcessor={code =>
            code.replace(/fill=".*?"/g, 'fill="currentColor"')
          }
          src={user}
          className="mr-1 lg:mr-2 w-5 lg:w-8"
        />
        <SVG
          onError={error => console.log(error.message)}
          cacheRequests={true}
          preProcessor={code =>
            code.replace(/stroke=".*?"/g, 'stroke="currentColor"')
          }
          src={chevron}
          className="w-6"
        />
        <span className="sr-only">
          Behaviour Account
        </span>
      </motion.a>
    </nav>
  )
}

export default NavUtils
